import { TimeRange } from "./time-range";
import { isNumber } from "./numbers";

export function formatTime(
  timeInMinutes: TimeRange | number,
  options: {
    lowerUpperSeperator?: string;
    hoursSuffix?: string;
    minutesSuffix?: string;
    hoursMinutesSeperator?: string;
  } = {
    lowerUpperSeperator: " to ",
    hoursSuffix: "",
    minutesSuffix: "",
    hoursMinutesSeperator: ":",
  }
): string {
  if (isNumber(timeInMinutes) || !!timeInMinutes.timeSingle) {
    const timeValue = Number((timeInMinutes as TimeRange)?.timeSingle ?? timeInMinutes);

    const hours = new String(Math.floor(timeValue / 60));
    const minutes = new String(timeValue % 60).padStart(2, "0");
    const { hoursSuffix, minutesSuffix, hoursMinutesSeperator } = options;
    return `${hours}${hoursSuffix}${hoursMinutesSeperator}${minutes}${minutesSuffix}`;
  } else {
    const lower = timeInMinutes.timeLower ? formatTime(timeInMinutes.timeLower, options) : "--:--";
    const upper = timeInMinutes.timeUpper ? formatTime(timeInMinutes.timeUpper, options) : "--:--";
    const { lowerUpperSeperator } = options;
    return `${lower}${lowerUpperSeperator}${upper}`;
  }
}
